import QuestionType from "../lib/QuestionType";
import { QuestionTypeEnum } from "../../../common/QuestionFieldType";

const QUESTION_SURVEY_TYPES: QuestionType[] = [
  new QuestionType(QuestionTypeEnum.CHECKBOX, false),
  new QuestionType(QuestionTypeEnum.RADIO, false),
  // new QuestionType(QuestionTypeEnum.SELECT, false),
  new QuestionType(QuestionTypeEnum.TEXTFIELD, false),
  new QuestionType(QuestionTypeEnum.TEXTAREA, false),
  new QuestionType(QuestionTypeEnum.INLINE_SELECT, false)
]

const QUESTION_TEST_TYPES: QuestionType[] = [
  new QuestionType(QuestionTypeEnum.CHECKBOX, true),
  new QuestionType(QuestionTypeEnum.RADIO, true),
  // new QuestionType(QuestionTypeEnum.SELECT, true),
  new QuestionType(QuestionTypeEnum.TEXTFIELD, true),
  new QuestionType(QuestionTypeEnum.TEXTAREA, true),
  new QuestionType(QuestionTypeEnum.MULTI_CHECKBOX, true),
  new QuestionType(QuestionTypeEnum.INLINE_SELECT, true)
]

const QUESTION_TYPES = QUESTION_SURVEY_TYPES.concat(QUESTION_TEST_TYPES);

export {QUESTION_SURVEY_TYPES, QUESTION_TEST_TYPES, QUESTION_TYPES};
